import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card } from '@mui/material';
import { oshaHipaaIcon } from '../../../icons';

import { selectChildPractices, selectCustomerNumber, selectLoadingState } from '../../../redux/customer';
import PracticesTable from './PracticesTable';
import { ComplianceStatus, LoadingState } from '../../../types';
import { ComplianceFilterOptions, PracticeStats } from './types';
import PageHeader from '../../../components/PageHeader';
import { getPracticeCompliance, getPracticeComplianceCounts, getPracticeCompliancePercentages, getPracticeStats } from './utils';
import ComplianceStatusTable from './tables/ComplianceStatusTable';
import PracticeStatsTable from './tables/PracticeStatsTable';

const OshaHipaaDashboard = () => {
  const [complianceFilter, setComplianceFilter] = useState<ComplianceFilterOptions>('')
  const [practiceStats, setPracticeStats] = useState<PracticeStats | null>(null)
  const [complianceCounts, setComplianceCounts] = useState<Record<ComplianceStatus, number> | null>(null)
  const [compliancePercentages, setCompliancePercentages] = useState<Record<ComplianceStatus, number> | null>(null)

  const childPractices = useSelector(selectChildPractices)
  const loadingState = useSelector(selectLoadingState)
  const customerNumber = useSelector(selectCustomerNumber)

  const handleComplianceFilter = (filter: ComplianceFilterOptions) => {
    if (filter === complianceFilter) {
      setComplianceFilter('');
    } else {
      setComplianceFilter(filter);
    }
  };

  useEffect(() => {
    if (customerNumber && loadingState === LoadingState.Done) {
      const compliances = childPractices.map(child => {
        return getPracticeCompliance(child)
      })

      const statistics = getPracticeStats(compliances)
      const complianceCounts = getPracticeComplianceCounts(compliances)
      const compliancePercentages = getPracticeCompliancePercentages(compliances, complianceCounts)

      setPracticeStats(statistics)
      setComplianceCounts(complianceCounts)
      setCompliancePercentages(compliancePercentages)
    }
  }, [customerNumber, loadingState])

  return (
    <>
      <PageHeader src={oshaHipaaIcon} headerName={'OSHA/HIPAA'} />
      <div className="m-12">
        <div className="flex flex-space-between flex-align-start m-b-16">
          <Card variant="outlined" className="m-r-25 flex-1">
            <div className="box-header">Compliance Status</div>
            <ComplianceStatusTable
              complianceCounts={complianceCounts}
              complianceFilter={complianceFilter}
              compliancePercentages={compliancePercentages}
              handleComplianceFilter={handleComplianceFilter}
            />
          </Card>
          <Card variant="outlined" className="flex-1">
            <div className="box-header">Stats</div>
            <PracticeStatsTable practiceStats={practiceStats} />
          </Card>
        </div>
        <PracticesTable complianceFilter={complianceFilter} handleComplianceFilter={handleComplianceFilter} />
      </div>
    </>
  );
}

export default OshaHipaaDashboard
